import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const MetaTags = ({ title, keywords, description, ogUrl, ogImage }) => (
  <Helmet>
    {title && <title>{title}</title>}

    {keywords && <meta name="keywords" content={keywords} />}

    {description && <meta name="description" content={description} />}

    {title && <meta name="og:title" content={title} />}

    {description && <meta name="og:description" content={description} />}

    {ogUrl && <meta property="og:url" content={ogUrl} />}

    {ogImage && <meta property="og:image" content={ogImage} />}
  </Helmet>
);

MetaTags.propTypes = {
  title: PropTypes.string,
  keywords: PropTypes.string,
  description: PropTypes.string,
  ogUrl: PropTypes.string,
  ogImage: PropTypes.string,
};

MetaTags.defaultProps = {
  title: 'evee | Tesla & Electric Car Rental in Australia',
  keywords: '',
  description: '',
  ogUrl: '',
  ogImage: '',
};

export default MetaTags;
